<template>
  <div>
    <div id="overlay"  v-if="loading">
      <div class="spinner"></div>
      <br/>
        <h4>Loading...</h4>
    </div>
        <form>
          <div class="p-grid justify-content-end">
          <div class="p-col">
            <Button class="p-button p-component p-button-success addNewBtn btn-btm-0"  @click.prevent="openAddDialog" icon="pi pi-plus" label="NEW" />
          </div>
        </div>
          <Dialogs  header="Visitor"  :visible.sync="addDisplayBasic" :style="{width: '50vw'}"
          :modal="true" :closable=false :contentStyle="{'overflow': 'visible'}">
            <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12 p-md-6">
                <label for="name" >Name<span style="color:red">*</span></label>
                <InputText id="name" v-model.trim="name" />
              </div>

              <div class="p-field p-col-12 p-md-6">
                <label for="address" >Address<span style="color:red">*</span></label>
                <InputText id="address" v-model.trim="address" />
              </div>

              <div class="p-field p-col-12 p-md-6">
                <label for="contactnumber" >Contact Number<span style="color:red">*</span></label>
                <InputText id="contactnumber" v-model.trim="contactnumber" />
              </div>
         
              <div class="p-field p-col-12 p-md-6">
                <label for="email" >Email<span style="color:red">*</span></label>
                <InputText id="email" v-model.trim="email" />
              </div>

              <div class="p-field p-col-12 p-md-6">
                <label for="purpose" >Purpose</label>
               <InputText id="purpose" v-model.trim="purpose" />
              </div>

                   
              <div class="p-field p-col-12 p-md-6">
                <label for="visittoid" >Visit To</label>
               <InputText id="visittoid" v-model.trim="visitTo" />
              </div>

              <div class="p-field p-col-12 p-md-6">
                <label for="inTime">In Time</label>
                <DatePicker 
                  v-model="inTime" 
                  type="time" 
                  id="inTime"
                  placeholder="Select time (HH:mm)"
                  :time-picker-options="{
                    start: '08:00',
                    step: '00:30',
                    end: '20:00'
                  }"
                  format="HH:mm"
                  value-type="format"
                />
                <small class="p-d-block p-mt-1 p-text-secondary">
                  Enter time in 24-hour format (e.g., 14:30)
                </small>
              </div>

              <div class="p-field p-col-12 p-md-6">
                <label for="outTime">Out Time</label>
                <DatePicker 
                  v-model="outTime" 
                  type="time" 
                  id="outTime"
                  placeholder="Select time (HH:mm)"
                  :time-picker-options="{
                    start: '08:00',
                    step: '00:30',
                    end: '20:00'
                  }"
                  format="HH:mm"
                  value-type="format"
                />
                <small class="p-d-block p-mt-1 p-text-secondary">
                  Enter time in 24-hour format (e.g., 14:30)
                </small>
              </div>

            <div class="p-field p-col-12 p-md-6">
                <label for="description">Description</label>
                <Textarea id="description" rows="3" class="form-control" v-model="remarks"/>
              </div>

      </div>
      <template #footer>
        <Button class="p-button-raised p-button" @click.prevent="addTicketDetails" :label="editing?'Update':'Add'"/>
        <Button class="p-button-raised p-button-primary" label="Add & New" @click.prevent="addAndNewTicketDetails" v-if="!editing"/>
        <Button  @click.prevent="addCancel" class="p-button-raised p-button-danger" label="Cancel"/>
      </template>
      </Dialogs>
    </form>
  </div>
</template>
<script>
import Dropdown from 'primevue/dropdown'
import RadioButton from 'primevue/radiobutton'
import Dialogs from 'primevue/dialog'
import Toast from 'primevue/toast'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import InputMask from 'primevue/inputmask'
import DatePicker from 'vue2-datepicker'
import Textarea from 'primevue/textarea/Textarea'
export default {
  name: 'supplier',
  data() {
    return {
      name: '',
      contactnumber: '',
      visitTo: '',
      address: '',
      priority: '',
      purpose: '',
      email: '',
      remarks: '',
      inTime: '',
      outTime: '',
      dialogShow: false,
      addDisplayBasic: false,
      addDialog: false,
      editing: false,
      createUser: false,
      id: '',
      loading: false,
      columnList: '',
      // format: {start: '00:00', step: '00:30', end: '12:30', format: 'HH:mm'},
      filters: {}
    }
  },
  methods: {
    async addTicketDetails() {
      if (this.name === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Name cannot be empty!', life: 10000})
        return
      }
      if (this.contactnumber === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'contactnumber cannot be empty!', life: 10000})
        return
      }
      if (this.address === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'address cannot be empty!', life: 10000})
        return
      }
      if (this.email === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'email cannot be empty!', life: 10000})
        return
      }
      let resp = ''
      let accountMaster = {
        id: this.id,
        name: this.name,
        contactNumber: this.contactnumber,
        visitTo: this.visitTo,
        address: this.address,
        purpose: this.purpose,
        remarks: this.remarks,
        inTime: this.inTime,
        outTime: this.outTime,
        email: this.email
      }
      if (!this.editing) {
        this.loading = !this.loading
        resp = await this.$store.dispatch('createCrmVisitor', accountMaster)
        // this.$emit('set_supplier_master', resp.data.data)
        this.loading = false
      } else {
        this.loading = !this.loading
        resp = await this.$store.dispatch('updateCrmVisitor', accountMaster)
        this.loading = false
      }
      this.responseMessage(resp)
      this.closeAddDialog()
    },
    async addAndNewTicketDetails() {
      if (this.name === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Name cannot be empty!', life: 10000})
        return
      }
      if (this.contactnumber === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'contactnumber cannot be empty!', life: 10000})
        return
      }
      if (this.address === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'address cannot be empty!', life: 10000})
        return
      }
      if (this.email === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'email cannot be empty!', life: 10000})
        return
      }
      let resp = ''
      let accountMaster = {
        name: this.name,
        contactNumber: this.contactnumber,
        visitTo: this.visitTo,
        address: this.address,
        purpose: this.purpose,
        remarks: this.remarks,
        inTime: this.inTime,
        outTime: this.outTime,
        email: this.email
      }
      this.loading = !this.loading
      resp = await this.$store.dispatch('createCrmVisitor', accountMaster)
      this.loading = false
      this.responseMessage(resp)
    },
    responseMessage(resp) {
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 10000})
        this.reset()
        this.editing = false
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 10000})
      }
    },
    editCrmVisitor(data) {
      this.addDialog = true
      this.id = data.id
      this.editing = true
      this.name = data.name
      this.visitTo = data.visitTo
      this.address = data.address
      this.purpose = data.purpose
      this.remarks = data.remarks
      this.contactnumber = data.contactNumber
      this.inTime = data.inTime
      this.outTime = data.outTime
      this.email = data.email
      // if (this.openingBalance > 0) {
      //   this.openingDrCr = 'Cr'
      // } else {
      //   this.openingDrCr = 'Dr'
      // }
      // if (this.status === undefined) {
      //   this.status = 'INACTIVE'
      // }
      this.openAddDialog()
    },
    reset() {
      this.name = ''
      this.contactnumber = ''
      this.address = ''
      this.visitTo = ''
      this.purpose = ''
      this.remarks = ''
      this.inTime = ''
      this.outTime = ''
      this.email = ''
    },
    isNumber(evt) {
      evt = window.event
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    openDialog(id) {
      this.dialogShow = true
      this.accountId = id
    },
    openAddDialog() {
      this.addDisplayBasic = true
    },
    closeAddDialog() {
      this.addDisplayBasic = false
    },
    addCancel() {
      this.reset()
      this.closeAddDialog()
    }
  },
  components: {
    Dropdown,
    RadioButton,
    Dialogs,
    Toast,
    Button,
    InputText,
    InputMask,
    DatePicker,
    Textarea
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css">
</style>



// WEBPACK FOOTER //
// crmVisitorDetailsDialog.vue?753a2cc3